import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../utils/Methods";
import { IDS } from "../../utils/IDS";

//  Get All
export const GetAllWalletHistory = createAsyncThunk(
  "masters/wallet/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.history}?name=${filter?.name ||
          ""}&status=${filter.status || ""}&wallet_type_id=${filter?.type ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetAllWithdrawHistory = createAsyncThunk(
  "masters/wallet/get-all-waithdraw",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.WithdrawReq}?name=${filter?.name ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&status=${filter.status ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetAllBanks = createAsyncThunk(
  "masters/wallet/get-all-bank",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.Bank}?name=${filter?.name ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&status=${filter.status ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const AddBankAccount = createAsyncThunk(
  "wallet/AddBankAccount/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.Bank, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllGameHistory = createAsyncThunk(
  "masters/wallet/get-all-game",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.UserGame.history}?name=${filter?.name ||
          ""}&status=${filter.status || ""}&wallet_type_id=${filter?.type ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetAllDepositHistory = createAsyncThunk(
  "masters/wallet/get-all-deposite",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.Deposite}?name=${filter?.name ||
          ""}&status=${filter.status || ""}&wallet_type_id=${filter?.type ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const DepositeAmount = createAsyncThunk(
  "wallet/DepositeAmount/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.Deposite, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const DepositeImbGateway = createAsyncThunk(
  "wallet/DepositeAmountWithGateway/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.DepositeIMBGateway, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const DepositeAmountWithGateway = createAsyncThunk(
  "wallet/DepositeAmountWithGateway/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.DepositeWGateway, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const WithdrawAmount = createAsyncThunk(
  "wallet/WithdrawAmount/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.WithdrawReq, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

// Get Single
export const GetSingle = createAsyncThunk(
  "masters/wallet/get",
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.Wallet}/get-single/${id}?type=${type}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//  Create (Add)
export const Create = createAsyncThunk(
  "masters/wallet/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Wallet, data);

      return res; // The new country object
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//  WithdrawStatusChange
export const WithdrawStatusChange = createAsyncThunk(
  "masters/wallet/WithdrawstatusChange",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Wallet.WithdrawReq}/${id}`, data);

      if (res?.success) {
        return res;
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//  Delete
export const Delete = createAsyncThunk(
  "masters/wallet/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Masters.Wallet}/${id}`);
      return id; // Return the id of the deleted country
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//  Status
export const StatusWithdrawStatusChange = createAsyncThunk(
  "masters/wallet/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Wallet}/${id}`);
      console.log(res, "StatusWithdrawStatusChange");

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const DepositeAmountWithUSDT = createAsyncThunk(
  "wallet/DepositeAmountWithUSDT/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.DepositeAmountWithUSDT, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllDepositeUSDTHistory = createAsyncThunk(
  "masters/wallet/get-all-usdt-deposite",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.DepositeAmountWithUSDT}?name=${filter?.name ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&status=${filter.status ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllUSDTWallets = createAsyncThunk(
  "masters/wallet/get-all-usdt-wallets",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Wallet.USDTWallets}?name=${filter?.name ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&status=${filter.status ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const WithdrawUSDTAmount = createAsyncThunk(
  "wallet/WithdrawUSDTAmount/post",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Wallet.WithdrawUSDTAmount, data);
      if (res.success) {
        return res; // The new country object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const Slice = createSlice({
  name: "wallet",
  initialState: {
    data: [],
    banks: [],
    usdtWallets: [],
    selectedBank: (() => {
      try {
        const id = localStorage.getItem("selected_bank_id");
        return id ? { id: Number(id) } : null;
      } catch {
        return null;
      }
    })(),

    selectedUSDTWallet: (() => {
      try {
        const id = localStorage.getItem("selected_wallet_id");
        return id ? { id: Number(id) } : null;
      } catch {
        return null;
      }
    })(),
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    SetSelectedBank: (state, action) => {
      state.selectedBank = action.payload;
      // Also keep localStorage in sync
      localStorage.setItem("selected_bank_id", action.payload?.id);
    },
    ClearSelectedBank: (state) => {
      state.selectedBank = null;
      localStorage.removeItem("selected_bank_id");
    },

    SetUSDTWallet: (state, action) => {
      state.selectedUSDTWallet = action.payload;
      // Also keep localStorage in sync
      localStorage.setItem("selected_wallet_id", action.payload?.id);
    },
    ClearUSDTWallet: (state) => {
      state.selectedUSDTWallet = null;
      localStorage.removeItem("selected_wallet_id");
    },
  },
  extraReducers: (builder) => {
    builder

      // Handling all actions for GetSingle, Create, WithdrawStatusChange, Delete

      .addCase(GetAllUSDTWallets.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllUSDTWallets.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.usdtWallets = action.payload?.data || [];
      })
      .addCase(GetAllUSDTWallets.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllDepositeUSDTHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllDepositeUSDTHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllDepositeUSDTHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllWalletHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllWalletHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllWalletHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllWithdrawHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllWithdrawHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllWithdrawHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllBanks.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllBanks.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.banks = action.payload?.data || [];
      })
      .addCase(GetAllBanks.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllGameHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllGameHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllGameHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllDepositHistory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllDepositHistory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllDepositHistory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(WithdrawStatusChange.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(WithdrawStatusChange.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (wallet) => wallet.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(WithdrawStatusChange.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (wallet) => wallet.id !== action.payload.id,
        );
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusWithdrawStatusChange.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusWithdrawStatusChange.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (wallet) => wallet.id !== action.payload.id,
        ); // Remove the country with the deleted id
      })
      .addCase(StatusWithdrawStatusChange.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {
  SetSelectedBank,
  ClearSelectedBank,
  ClearUSDTWallet,
  SetUSDTWallet,
} = Slice.actions;

export default Slice.reducer;
